const stack: symbol[] = [];

export const modalStack = {
  push(id: symbol) {
    stack.push(id);
  },

  remove(id: symbol) {
    const idx = stack.indexOf(id);
    if (idx !== -1) stack.splice(idx, 1);
  },

  isTop(id: symbol): boolean {
    return stack.length > 0 && stack[stack.length - 1] === id;
  }
};
